import React, { useEffect, useRef, useState } from "react";
import "../common/common.css";
import "../common/style.css";
import "../common/responsive.css";

const JourneySection = () => {
  const [experienceYears, setExperienceYears] = useState(0);
  const [cities, setCities] = useState(0);
  const [households, setHouseholds] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement | null>(null);

  const totalDuration = 3000; // Total animation duration in milliseconds
  const experienceTarget = 15; // Target for years of experience
  const citiesTarget = 15; // Target for cities
  const householdsTarget = 40000; // Target for households (35 million or 350 lakh)

  useEffect(() => {
    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      const entry = entries[0];
      if (entry.isIntersecting && !hasAnimated) {
        setHasAnimated(true);
        startCounting();
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5, // Trigger when 50% of the section is visible
    });

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated]);

  const startCounting = () => {
    const interval = 50; // Update interval in milliseconds
    const totalSteps = totalDuration / interval;
  
    const experienceIncrement = experienceTarget / totalSteps;
    const citiesIncrement = citiesTarget / totalSteps;
    const householdsIncrement = householdsTarget / totalSteps;
  
    let currentExperience = 0;
    let currentCities = 0;
    let currentHouseholds = 0;
  
    const countingInterval = setInterval(() => {
      // Update experience
      currentExperience = Math.min(currentExperience + experienceIncrement, experienceTarget);
      setExperienceYears(Math.round(currentExperience));
  
      // Update cities
      currentCities = Math.min(currentCities + citiesIncrement, citiesTarget);
      setCities(Math.round(currentCities));
  
      // Update households
      currentHouseholds = Math.min(currentHouseholds + householdsIncrement, householdsTarget);
      setHouseholds(Math.round(currentHouseholds));
  
      // Stop all counters when all targets are reached
      if (
        Math.round(currentExperience) === experienceTarget &&
        Math.round(currentCities) === citiesTarget &&
        Math.round(currentHouseholds) === householdsTarget
      ) {
        clearInterval(countingInterval);
      }
    }, interval);
  };
  

  return (
    <section className="journey" ref={sectionRef}>
      <div className="container">
        <div className="journeyHeading">
          <h2 className="headingsText">Our Journey So Far</h2>
          <h5 className="topTexts">
            Experience the Joy of Effortlessly Selling Your Old Electronics
          </h5>
        </div>
        <div className="journeyDetails row">
          <div className="journeyCounts col-md-4">
            <h2 className="counts">{experienceYears}+ Years of Experience</h2>
            <h3 className="journeyText">
            India’s Largest recycler for e-waste and EV batteries
            </h3>
          </div>
          <div className="journeyCounts col-md-4">
            <h2 className="counts">{cities}+ Cities</h2>
            <h3 className="journeyText">
              Convenient, free doorstep pickup services all over India
            </h3>
          </div>
          <div className="journeyCounts col-md-4">
          <h2 className="counts">{households.toLocaleString()}+ Households*</h2>

            <h3 className="journeyText">
              On track to serve and recycle used electronics across the nation
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneySection;
